import React from 'react';
const Partners = () => {
  const partners = [{
    name: 'Sofitel',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Sofitel_logo.svg'
  }, {
    name: 'Saudia Airlines',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d4/Saudia_logo.svg'
  }, {
    name: 'Etihad Airways',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Etihad_Airways_logo_2022.svg'
  }, {
    name: 'Turkish Airlines',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Turkish_Airlines_Logo_2019.svg'
  }, {
    name: 'Ghufran Hotel',
    logo: 'https://placehold.co/200x80/f8fafc/64748b?text=Ghufran+Hotel'
  }];
  return <div className="py-16 bg-gray-50" data-id="element-520">
      <div className="container mx-auto px-4 md:px-8" data-id="element-521">
        <h2 className="text-3xl font-bold text-center text-navy-900 mb-10" data-id="element-522">
          Our Preferred Partners
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12" data-id="element-523">
          {partners.map((partner, index) => <div key={index} className="w-32 md:w-40 h-16 flex items-center justify-center grayscale hover:grayscale-0 transition-all" data-id="element-524">
              <img src={partner.logo} alt={partner.name} className="max-h-full max-w-full object-contain" data-id="element-525" />
            </div>)}
        </div>
      </div>
    </div>;
};
export default Partners;